<div class="modal-overlay">
  <div class="modal">
    <button class="close-btn" (click)="closeModal()" title="Close Modal">✕</button>
    <div class="modal-header">
      <div class="header-top">
        <h2 class="modal-title">Online Drivers</h2>
          <div class="header-actions">
            <button class="refresh-btn" (click)="refreshData()" title="Refresh Data" [class.spinning]="isLoading">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="refresh-icon">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg>
            </button>
            <div class="search-box">
              <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
              </svg>
              <input type="text" class="search-input" placeholder="Search drivers..." [(ngModel)]="searchTerm"
                (input)="onSearch()" />
              <svg *ngIf="searchTerm && searchTerm.length > 0" (click)="clearSearch()" class="cross-icon" width="16"
                height="16" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
          </div>
      </div>
    </div>

    <!-- Analytics — always visible, outside scrollable modal-body -->
    <!-- Analytics — always visible, outside scrollable modal-body -->
    <div class="analytics-summary">
      <ng-container *ngIf="!isLoading; else statsSkeleton">
        <div class="stat-card">
          <span class="stat-value">{{ totalActive }}</span>
          <span class="stat-label">Active Now</span>
        </div>
        <div class="stat-card">
          <span class="stat-value">{{ TotalOrders }} </span>
          <span class="stat-label">Total Orders</span>
        </div>
        <div class="stat-card">
          <span class="stat-value">{{ totalCompleted }}</span>
          <span class="stat-label">Completed Today</span>
        </div>
        <div class="stat-card" title="Average Delivery Time">
          <span class="stat-value">{{ avgETA }} min</span>
          <span class="stat-label">Avg Del Time</span>
        </div>
      </ng-container>

      <ng-template #statsSkeleton>
        <div class="stat-card" *ngFor="let i of [1,2,3,4]">
          <div class="skeleton-stat-value skeleton-block"></div>
          <div class="skeleton-stat-label skeleton-block"></div>
        </div>
      </ng-template>
    </div>

    <!-- Filter Tabs -->
    <div class="filter-tabs-wrapper">
      <div class="filter-tabs">
        <button type="button" class="filter-tab" *ngFor="let tab of filterTabs" 
          [class]="tab.key"
          [class.active]="activeFilter === tab.key"
          (click)="filterDrivers(tab.key)">
          {{ tab.label }}
          <span class="tab-count">{{ tab.count }}</span>
        </button>
      </div>
    </div>

    <!-- Drivers -->
    <div class="scroll-wrapper">
      <div class="scrollable-content">
        <div class="driver-list">
          <ng-container *ngIf="!isLoading; else listSkeleton">
            <div *ngFor="let driver of paginatedDrivers" class="driver-card"
              [class.enroute]="driver.driver_order_status === 'en-route'"
              [class.active-card]="activeContactId === driver.id">
              <!-- ... existing driver card content ... -->
              <div class="driver-avatar">
                <img *ngIf="driver.profile_image" [src]="driver.profile_image" class="avatar-img"
                  [alt]="driver.first_name" title="Driver Profile Image" />
                <ng-container *ngIf="!driver.profile_image">
                  {{ getInitials(driver.first_name, driver.last_name) }}
                </ng-container>
              </div>

              <div class="driver-info">
                <div class="driver-name">
                  <span>{{ driver.first_name }} {{ driver.last_name }}</span>
                  <span class="driver-rating">⭐ {{ getDriverRating(driver) }}%</span>
                  <span class="offline-badge" *ngIf="driver?.is_online === false || driver?.is_online === 'false'">OFFLINE</span>
                </div>
                <div class="driver-stats">
                  <span>{{ driver.completed_deliveries_count }}/{{ driver.assigned_orders_count }} completed</span>
                  <span>📍{{ getBackWarehouseDistanceText(driver) }}</span>
                  <span class="time-back">Back by <span [class.na-text]="getEstimatedReturn(driver) === 'NA'">{{ getEstimatedReturn(driver) }}</span></span>
                </div>
                <div class="driver-actions-row">
                  <div class="contact-trigger-wrapper">
                    <button type="button" class="action-btn call" (click)="callDriver(driver, $event)" title="Call Driver" [class.active]="activeContactId === driver.id">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                      </svg>
                      <span>Contact</span>
                    </button>
                    <div class="contact-popover" *ngIf="activeContactId === driver.id" (click)="$event.stopPropagation()">
                      <div class="popover-arrow"></div>
                      <div class="popover-header">
                        <span class="popover-name">{{ driver.first_name }} {{ driver.last_name }}</span>
                        <span class="popover-phone">{{ getDriverPhone(driver) }}</span>
                      </div>
                      <div class="popover-actions">
                        <button class="popover-btn call" (click)="initiateCall(getDriverPhone(driver), $event)" title="Call Now">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                          </svg>
                        </button>
                        <button class="popover-btn whatsapp" (click)="openWhatsApp(getDriverPhone(driver), $event)" title="WhatsApp Chat">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.06 3.973L0 16l4.14-1.086c1.162.634 2.478.969 3.811.969h.005a7.862 7.862 0 0 0 5.86-2.569 7.854 7.854 0 0 0 2.23-5.611c.002-2.112-.822-4.095-2.316-5.592h-.001zm-5.607 11.458h-.003a6.55 6.55 0 0 1-3.342-.915l-.24-.143-2.484.652.662-2.42-.156-.248a6.539 6.539 0 0 1-1.003-3.484c.002-3.605 2.942-6.545 6.548-6.545a6.548 6.548 0 0 1 4.632 1.92 6.548 6.548 0 0 1 1.916 4.636c-.002 3.605-2.942 6.545-6.548 6.545zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.089-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                          </svg>
                        </button>
                        <button class="popover-btn copy" (click)="copyToClipboard(getDriverPhone(driver), $event, driver.id)" title="Copy Number">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
                          </svg>
                        </button>
                      </div>
                      <div class="copied-badge" *ngIf="showCopiedId === driver.id">
                        <span>Copied!</span>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="action-btn track" (click)="trackDriver(driver)" title="Track Driver">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                    </svg>
                    <span>Track</span>
                  </button>
                </div>
              </div>

              <div class="driver-status-wrapper">
                <div class="driver-status"
                  [ngClass]="driver.driver_order_status ? getStatusConfig(driver.driver_order_status).class : getStatusConfig(activeFilter).class">
                  {{ driver.driver_order_status ? getStatusConfig(driver.driver_order_status).label :
                  getStatusConfig(activeFilter).label }}
                </div>
                <!-- last_active_status -->
                <span class="last-active">Updated: {{ getLastActive(driver.last_active_status) }}</span>
              </div>
            </div>
          </ng-container>

          <ng-template #listSkeleton>
            <div class="skeleton-driver-card" *ngFor="let i of [1,2,3,4,5]">
              <div class="skeleton-avatar skeleton-block"></div>
              <div class="driver-info">
                <div class="skeleton-info-line skeleton-line-lg skeleton-block"></div>
                <div class="skeleton-info-line skeleton-line-md skeleton-block"></div>
                <div class="skeleton-info-line skeleton-line-sm skeleton-block"></div>
              </div>
              <div class="skeleton-status-box skeleton-block"></div>
            </div>
          </ng-template>
        </div>

        <!-- Empty State (Only shows after loading and when no drivers found) -->
        <div *ngIf="!isLoading && paginatedDrivers.length === 0" class="empty-drivers-state">
          <div class="empty-state-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125a1.125 1.125 0 0 0 1.125-1.125V11.16a2.999 2.999 0 0 0-1.507-2.597l-2.25-1.3a2.999 2.999 0 0 0-2.992 0l-2.25 1.3a2.999 2.999 0 0 0-1.507 2.597v6.465m-2.25 4.5H8.25m6.75 0h-6.75" />
            </svg>
          </div>
          <h3>{{ emptyStateConfig.title }}</h3>
          <p>{{ emptyStateConfig.message }}</p>
        </div>
      </div>
    </div>
  </div>
</div>